var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsFolder = function SvgIconsFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.2 2.333h-3c-1.03 0-1.867.782-1.867 1.75v7.835c0 .967.838 1.749 1.867 1.749h9.6c1.03 0 1.867-.782 1.867-1.75V5.762l-.004-.106c-.059-.918-.872-1.643-1.863-1.643H7.753l-1-1.401c-.124-.174-.331-.278-.553-.278zm-3 1.26h2.646l1.001 1.401c.124.174.331.278.553.278h5.4c.296 0 .533.22.533.49v6.156c0 .268-.237.49-.533.49H3.2c-.296 0-.533-.222-.533-.49V4.082c0-.268.237-.49.533-.49z"
  })));
};
export default SvgIconsFolder;